import React, { Component } from 'react';
import { connect } from 'react-redux';
import ErrorDisplay from '../utility/ErrorDisplay';
import LottieLoader from '../utility/LottieLoader';
import { Helmet } from 'react-helmet';
import CoverPhoto from '../utility/CoverPhoto';
import TravelCompanions from './TravelCompanions';
import TripInfo from '../TripDetails/TripInfo';
import Itinerary from '../TripDetails/Itinerary';
import ItemList from '../TripDetails/ItemList';
import AdditionalInfo from '../TripDetails/AdditionalInfo';
import ContentBlock from '../TripDetails/ContentBlock';
import MeetingPoint from './MeetingPoint';
import ButtonLink from '../utility/ButtonLink';
import { PropTypes } from 'prop-types';
import { withTranslation } from 'react-i18next';

import { fetchMyBookingDetails } from '../../actions/myBookings';

import { formatDate } from '../../js/utility';

import { clearApiError } from '../../actions/api';

import { SITE_TITLE } from '../../constants';

class BookingDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initData: false
    };
    this.initData = this.initData.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    this.props.clearApiError();
    this.initData();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  async initData() {
    const uuid = this.props.match.params.slug;
    const { fetchMyBookingDetails } = this.props;
    await fetchMyBookingDetails(uuid);
    this.setState({
      initData: true
    });
  }

  render() {
    const { initData } = this.state;
    const { error, loading } = this.props;
    if (error) {
      return <ErrorDisplay error={error} />;
    }
    if (loading || !initData) {
      return <LottieLoader />;
    }
    const { bookingDetails, t } = this.props;

    const uuid = this.props.match.params.slug;

    return (
      <>
        <Helmet>
          <title>
            {t('trip:yourBookings')} - {bookingDetails.trip} | {SITE_TITLE}
          </title>
        </Helmet>
        <div className='fe-my-booking-info-container'>
          <header className='fe-my-booking-info-header'>
            <div className='fe-my-booking-info-header-content'>
              <div className='container'>
                <div className='fe-my-booking-info-date'>{`${formatDate(
                  bookingDetails.date
                )}, ${bookingDetails.time.toUpperCase()}`}</div>
                <h1 className='fe-my-booking-info-title'>
                  {bookingDetails.trip}
                </h1>
                <div className='fe-my-booking-info-location'>
                  {bookingDetails.location}
                </div>
              </div>
            </div>
            <CoverPhoto
              mobileUrl={bookingDetails.photo_cover.mobile_view}
              desktopUrl={bookingDetails.photo_cover.desktop_view}
            />
          </header>
          <div className='fe-trip-overflow-container'>
            <div className='fe-my-booking-info-content'>
              {bookingDetails.review ? (
                <div className='container'>
                  <div className='row'>
                    <div className='col-xl-8'>
                      <div className='fe-my-booking-review-cta'>
                        <p>{t('trip:reviewCTA')}</p>
                        <p>{t('trip:reviewCTA2')}</p>
                        <ButtonLink
                          to={`/leave-a-review/${bookingDetails.booking_uuid}`}
                        >
                          {t('trip:leaveAReview')}
                        </ButtonLink>
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
              <TravelCompanions
                bookingCode={bookingDetails.booking_code}
                companions={bookingDetails.companions}
                uuid={uuid}
                isEditable={bookingDetails.is_editable}
              />
              {/* <TripInfo
                description={bookingDetails.description}
                recVehicle={bookingDetails.vehicle}
                isOwnVehicle={bookingDetails.byor}
                vehicleNo={bookingDetails.vehicle_registration_no}
              /> */}
              {!bookingDetails.byor && (
                <MeetingPoint meetingPoint={bookingDetails.meeting_point} />
              )}
              {bookingDetails.itinerary &&
              bookingDetails.itinerary.length > 0 ? (
                <Itinerary
                  itinerary={bookingDetails.itinerary}
                  theme={bookingDetails.theme}
                  sidePhotos={bookingDetails.itinerary_img}
                  galleryPrefix={uuid}
                />
              ) : null}
              <ItemList
                title={t('trip:whatToBring')}
                items={bookingDetails.items_to_bring}
              />
              <ItemList
                title={t('trip:whatsIncluded')}
                items={bookingDetails.whats_included}
              />
              <AdditionalInfo
                additionalInfo={bookingDetails.additional_information}
              />
              <ContentBlock
                title={t('trip:cancellationPolicy')}
                description={bookingDetails.cancellation_policy}
              />
            </div>
          </div>
        </div>
      </>
    );
  }
}

BookingDetails.propTypes = {
  clearApiError: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  fetchMyBookingDetails: PropTypes.func.isRequired,
  error: PropTypes.object,
  loading: PropTypes.bool.isRequired,
  bookingDetails: PropTypes.object,
  t: PropTypes.func.isRequired
};

const mapStateToProps = ({ apiState, myBookingsState }) => ({
  loading: myBookingsState.loading,
  error: apiState.error,
  bookingDetails: myBookingsState.bookingDetails
});

const mapDispatchToProps = {
  fetchMyBookingDetails,
  clearApiError
};

export default withTranslation()(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(BookingDetails)
);
